import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./../Styles/services.css";
import { BASE_URL } from "../../config/api";
const DynamicImage = ({ name, alt, className }) => {
  const extensions = ["jpg", "jpeg", "png", "webp"];
  const [extensionIndex, setExtensionIndex] = useState(0);

  const handleError = (e) => {
    if (extensionIndex < extensions.length - 1) {
      setExtensionIndex((prev) => prev + 1);
    } else {
      e.target.style.display = "none";
    }
  };

  return (
    <img
      src={`/images/marketing/${name}.${extensions[extensionIndex]}`}
      alt={alt}
      className={className}
      onError={handleError}
    />
  );
};
export default function Services() {
  const [instagramPosts, setInstagramPosts] = useState([]);
  useEffect(() => {
    document.title = "Our Services | LifeTime Group";
  }, []);
  useEffect(() => {
    const getInstagramPosts = async () => {
      try {
        const response = await fetch(`${BASE_URL}/instagram.php`);

        const result = await response.json();

        if (result.success) {
          setInstagramPosts(result.data.slice(0, 5));
        }
      } catch (error) {
        console.log("Instagram error:", error);
      }
    };

    getInstagramPosts();
  }, []);

  return (
    <>
      <Helmet>
        {/* Basic SEO */}
        <title>Our Services | LifeTime Group</title>

        <meta
          name="description"
          content="Explore LifeTime Group services including website development, mobile applications, embroidery design courses, Embroidery Bazar, and professional embroidery training."
        />

        <meta name="robots" content="index, follow" />

        {/* Canonical */}
        <link rel="canonical" href="https://lifetimecreation.in/services" />

        {/* Open Graph */}
        <meta property="og:title" content="Our Services | LifeTime Group" />

        <meta
          property="og:description"
          content="Explore LifeTime Group services including website development, mobile applications, embroidery design courses, Embroidery Bazar, and professional embroidery training."
        />

        <meta property="og:type" content="website" />

        <meta
          property="og:url"
          content="https://lifetimecreation.in/services"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />

        <meta name="twitter:title" content="Our Services | LifeTime Group" />

        <meta
          name="twitter:description"
          content="Explore LifeTime Group services including website development, mobile applications, embroidery design courses, Embroidery Bazar, and professional embroidery training."
        />
      </Helmet>

      {/* Hero */}
      <section className="services-hero">
        <div className="services-overlay"></div>

        <div className="services-content">
          <span>
            <i className="bi bi-gear-fill"> </i> Our Services
          </span>

          {/* <h1>Technology, Creativity & Professional Training Under One Roof</h1> */}

          <h2>
            Complete Technology solutions and Embroidery Design Training
            Services.
          </h2>
        </div>
      </section>

      {/* Main Services */}
      <section className="service-section">
        <div className="service-card">
          <div className="row">
            <div className="col-md-5">
              <div style={{ display: "flex", alignItems: "center" }}>
                <div className="service-icon">
                  <i className="bi bi-code-slash"></i>
                </div>

                <h2 className="embroidery-title">LifeTime Infotech</h2>
              </div>
              <p>
                Build your digital identity with modern websites, mobile
                applications and business solutions.
              </p>

              <div className="service-list">
                <div>
                  <i className="bi bi-check-circle-fill"></i>
                  Website Development
                </div>

                <div>
                  <i className="bi bi-check-circle-fill"></i>
                  Android Applications
                </div>

                <div>
                  <i className="bi bi-check-circle-fill"></i>
                  E-Commerce Websites
                </div>

                <div>
                  <i className="bi bi-check-circle-fill"></i>
                  UI/UX Design & Maintenance
                </div>
                <a
                  href="https://wa.me/919909614445?text=Hello%20I%20want%20more%20information"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whatsapp-btn"
                >
                  <i className="bi bi-whatsapp" style={{ color: "white" }}></i>
                  Chat on WhatsApp
                </a>
              </div>
            </div>
            <div className="col-md-7">
              <div className="image-box">
                <DynamicImage
                  name="lifetimeinfotech"
                  alt="LifeTime Infotech"
                  className="img-fluid1"
                />

                <div className="image-overlay">
                  <a
                    href="https://www.lifetimeinfotech.in"
                    target="_blank"
                    rel="noreferrer"
                    className="image-btn"
                  >
                    <i className="bi bi-code-slash"> </i>
                    Visit LifeTime Infotech
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="service-card">
          <div className="row">
            <div className="col-md-5">
              <div style={{ display: "flex", alignItems: "center" }}>
                <div className="service-icon education"></div>

                <h2>
                  <span>LifeTime</span> <br /> Embroidery Design Course
                </h2>
              </div>
              <p>
                Learn Wilcom E4 embroidery designing with Online & Offline
                training programs.
              </p>

              <div className="service-list">
                <div>
                  <i className="bi bi-check-circle-fill"></i>
                  Online Course
                </div>

                <div>
                  <i className="bi bi-check-circle-fill"></i>
                  Offline Course
                </div>

                <div>
                  <i className="bi bi-check-circle-fill"></i>
                  Basic To Advanced Wilcom E4
                </div>

                <div>
                  <i className="bi bi-check-circle-fill"></i>
                  Real Project Training
                </div>

                <div>
                  <i className="bi bi-check-circle-fill"></i>
                  LifeTime Support
                </div>
              </div>
              <a
                href="https://wa.me/919909614445?text=Hello%20I%20want%20more%20information"
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp-btn"
              >
                <i className="bi bi-whatsapp"></i>
                Chat on WhatsApp
              </a>
            </div>
            <div className="col-md-7">
              <div className="image-box">
                <DynamicImage
                  name="embroiderycourse"
                  alt="embroidery design course"
                  className="img-fluid1"
                />

                <div className="image-overlay">
                  <a
                    href="https://www.embroiderydesigncourse.com"
                    target="_blank"
                    rel="noreferrer"
                    className="image-btn"
                  >
                    <i className="bi bi-mortarboard"> </i>
                    See Course Details
                  </a>
                </div>
              </div>
            </div>

            <div className="row img">
              <div className="col-md-4">
                <div className="image-box">
                  <DynamicImage
                    name="offline"
                    alt="Offline Course"
                    className="img-fluid1"
                  />

                  <div className="image-overlay">
                    <a
                      href="https://www.embroiderydesigncourse.com"
                      target="_blank"
                      rel="noreferrer"
                      className="image-btn"
                    >
                      <i className="bi bi-mortarboard"> </i>
                      Offline Course
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="image-box">
                  <DynamicImage
                    name="online"
                    alt="Online Course"
                    className="img-fluid1"
                  />

                  <div className="image-overlay">
                    <a
                      href="https://www.embroiderydesigncourse.com"
                      target="_blank"
                      rel="noreferrer"
                      className="image-btn"
                    >
                      <i className="bi bi-mortarboard"> </i>
                      Online Course
                    </a>
                  </div>
                </div>
              </div>

              <div className="col-md-4">
                <div className="image-box">
                  <DynamicImage
                    name="Youtube"
                    alt="youtube"
                    className="img-fluid1"
                  />

                  <div className="image-overlay">
                    <a
                      href="https://www.youtube.com/@lifetimecreationltc9063"
                      target="_blank"
                      rel="noreferrer"
                      className="image-btn youtube"
                    >
                      <i className="bi bi-youtube"> </i>
                      Free YouTube Classes
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="service-section">
        <div className="service-card">
          <div className="row">
            {/* Left Content */}
            <div className="col-md-5">
              <div style={{ display: "flex", alignItems: "center" }}>
                <div className="service-icon">
                  <i className="bi bi-cpu-fill"></i>
                </div>

                <h2 className="embroidery-title">Embroidery Bazar</h2>
              </div>
              <p>
                A complete embroidery industry ecosystem where designers,
                machine owners, and embroidery businesses connect and grow
                together.
              </p>

              <div className="service-list">
                <div>
                  <i className="bi bi-check-circle-fill"></i>
                  Free Embroidery Designs
                </div>

                <div>
                  <i className="bi bi-check-circle-fill"></i>
                  Buy & Sell Old Embroidery Machines
                </div>

                <div>
                  <i className="bi bi-check-circle-fill"></i>
                  Rent Embroidery Workspaces
                </div>

                <div>
                  <i className="bi bi-check-circle-fill"></i>
                  Hire & Get Hired as Embroidery Designer
                </div>

                <div>
                  <i className="bi bi-check-circle-fill"></i>
                  Complete Digital Marketplace for Embroidery Industry
                </div>
              </div>
            </div>

            {/* Right Image */}
            <div className="col-md-7">
              <div className="image-box">
                <DynamicImage
                  name="embroiderybazar"
                  alt="Embroidery Bazar Platform"
                  className="img-fluid1"
                />

                <div className="image-overlay">
                  <a
                    href="https://embroiderybazar.in"
                    target="_blank"
                    rel="noreferrer"
                    className="image-btn"
                  >
                    <i className="bi bi-houses"> </i>
                    Visit Embroidery Bazar Website
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}

      {/* <section className="activities-section">
        <div className="activities-header">
          <span>
            <i className="bi bi-camera-fill"></i>
            Our Services
          </span>

          <h2>We Provide Following Services</h2>
        </div>

        <div className="activities-grid">
          <div className="activity-card">
            <img src="/images/marketing/offline.jpg" alt="Student Training" />

            <div className="activity-content">
              <h3>
                <i className="bi bi-mortarboard-fill"></i>
                Student Training Session
              </h3>

              <p>
                Practical Wilcom E4 training with our students during live
                classes.
              </p>
            </div>
          </div>

          <div className="activity-card">
            <img src="/images/marketing/2.png" alt="Embroidery Design" />

            <div className="activity-content">
              <h3>
                <i className="bi bi-vector-pen"></i>
                New Embroidery Designs
              </h3>

              <p>
                Creative commercial embroidery designs developed by our team.
              </p>
            </div>
          </div>

          <div className="activity-card">
            <img src="/images/marketing/1.jpg" alt="Software Development" />

            <div className="activity-content">
              <h3>
                <i className="bi bi-code-slash"></i>
                Website & App Projects
              </h3>

              <p>
                Modern websites, applications and digital solutions for
                businesses.
              </p>
            </div>
          </div>

          <div className="activity-card">
            <img src="/images/marketing/13.jpg" alt="YouTube Classes" />

            <div className="activity-content">
              <h3>
                <i className="bi bi-youtube"></i>
                Free YouTube Classes
              </h3>

              <p>
                Sharing embroidery knowledge and professional tips with
                thousands of learners.
              </p>
            </div>
          </div>
        </div>
      </section> */}
      <section className="activities-section">
        <div className="activities-header">
          <span>
            <i className="bi bi-instagram"></i>
            Daily Updates
          </span>

          <h2>Latest Instagram Activities</h2>

          <p>See our latest student moments and embroidery designs.</p>
        </div>

        <div className="instagram-grid">
          {instagramPosts.map((post) => (
            <a
              key={post.id}
              href={post.permalink}
              target="_blank"
              rel="noreferrer"
              className="instagram-card"
            >
              {post.media_type === "VIDEO" ? (
                <video>
                  <source src={post.media_url} />
                </video>
              ) : (
                <img src={post.media_url} alt="Instagram Activity" />
              )}

              <div className="instagram-overlay">
                <i className="bi bi-instagram"></i>

                <span>View On Instagram</span>
              </div>
            </a>
          ))}
        </div>

        <div className="activities-footer">
          <a
            href="https://instagram.com/lifetime_embroidery_designclas"
            target="_blank"
            rel="noreferrer"
            className="instagram-follow-btn"
          >
            <i className="bi bi-instagram"></i>
            Follow For Daily Updates
          </a>
        </div>
      </section>
      {/* Contact CTA */}
      <section className="service-cta">
        <h2>Let's Build Your Future Together</h2>

        <p>
          Whether you need a website or want to learn a valuable embroidery
          skill, we are here to guide you.
        </p>

        <div className="cta-buttons">
          <a href="tel:+919909614445">
            <i className="bi bi-telephone-fill"></i>
            Call Us
          </a>

          <a href="https://wa.me/919909614445" target="_blank" rel="noreferrer">
            <i className="bi bi-whatsapp"></i>
            WhatsApp
          </a>
        </div>
      </section>
    </>
  );
}
